import React from 'react';
import { agentColor, agentLabel } from '../../agents.js';
import { fx } from '../../fx.js';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * A row of agent initials showing who has access; clickable when onToggle is given.
 *
 * @param {object} p
 * @param {{ name: 'alf'|'alfred'|'claw'|'main'|'penny'|'scout'|'flux'|string; on: boolean }[]} [p.agents]
 * @param {(name: string) => void} [p.onToggle]
 * @param {number} [p.size]
 */
export function AccessRow({ agents = [], onToggle, size = 22 }) {
  return h('div', { style: { display: 'flex', gap: 6, alignItems: 'center' } },
    agents.map((a) => h('span', {
      key: a.name, title: `${agentLabel(a.name)} · ${a.on ? 'has access' : 'no access'}`, onClick: onToggle ? (e) => { fx.boop && fx.boop(e.currentTarget, 1.2); onToggle(a.name); } : undefined, className: onToggle ? 'hv-chip' : undefined,
      style: { display: 'inline-grid', placeItems: 'center', width: size, height: size, borderRadius: Math.round(size * .32), background: a.on ? agentColor(a.name) : 'var(--paper)', color: a.on ? '#fff' : 'var(--mut3)', border: a.on ? ink(1.5) : '1.5px solid var(--line2)', boxSizing: 'border-box', fontFamily: BODY, fontWeight: 800, fontSize: Math.round(size * .45), cursor: onToggle ? 'pointer' : undefined }
    }, agentLabel(a.name)[0])));
}
